'use strict';

(() => {
  const DL_FILTER_SELECT = 'data-datalayer-event="filter_interaction, Select"';
  const DL_FILTER_APPLY = 'data-datalayer-event="filter_interaction, Apply"';
  const DL_CTA = 'data-datalayer-event="cta_interaction"';

  const templates = {
    filterItem: `<div role="listitem" data-title="[[FILTER_TITLE]]" data-attr-key="[[FILTER_ATTR_KEY]]" class="widget sidebar-tags [[FILTER_ACCORDION_CLASS]]" role="region" aria-labelledby="filter-[[FILTER_ATTR_KEY]]">
                    <div class="widget-title">
                      <div class="sidebar-title" role="button" tabindex="0" [[FILTER_ACCORDION_ATTR]] id="filter-[[FILTER_ATTR_KEY]]" aria-controls="filter-content-[[FILTER_ATTR_KEY]]">
                        <span>[[FILTER_TITLE]]</span>
                        [[FILTER_SELECTED_COUNT]]
                        <svg fill="#000000" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 30.727 30.727" xml:space="preserve" class="icon icon-sidebar-chevron"><g><path d="M29.994,10.183L15.363,24.812L0.733,10.184c-0.977-0.978-0.977-2.561,0-3.536c0.977-0.977,2.559-0.976,3.536,0 l11.095,11.093L26.461,6.647c0.977-0.976,2.559-0.976,3.535,0C30.971,7.624,30.971,9.206,29.994,10.183z"></path></g></svg>
                      </div>
                    </div>
                    <div class="widget-content filter_search_wrapper collection-price-range" data-filter-option-container [[FILTER_ACCORDION_STYLE]] id="filter-content-[[FILTER_ATTR_KEY]]" role="group">
                      [[FILTER_SEARCH_BOX]]
                      <ul class="list-tags">
                        [[FILTER_OPTIONS]]
                      </ul>
                    </div>
                </div>`,
    filterOption: `<li role="listitem" [[FILTER_OPTION_STYLE]]>
                      <input aria-controls="sr-status" type="checkbox" id="[[FILTER_OPTION_ID]]" value="[[FILTER_OPTION_VALUE]]" [[FILTER_OPTION_ARIA_LABEL]] [[FILTER_OPTION_SELECTED]] ${DL_FILTER_SELECT} />
                      <label for="[[FILTER_OPTION_ID]]" [[FILTER_OPTION_LABEL_ATTRS]] ${DL_FILTER_SELECT}>[[FILTER_OPTION_TITLE]]</label>
                    </li>`,
    filterPriceOption: `<li role="presentation" data-value="Price" class="price-filter-wrapper">
                            <fieldset class="price-range-fieldset">
                                <legend class="visually-hidden">Price Range</legend>
                                <ul class="price-range-list">
                                    [[DYNAMIC_PRICE_RADIOS]]
                                    <li class="price-range-item price-custom-item">
                                        <div class="price-custom-inputs-wrap">
                                            <div class="price-inputs-row">
                                                <input type="number" id="price-min-input" class="price-min-input" data-price-min-input placeholder="$ Min" min="0" value="[[CUSTOM_MIN]]" aria-label="Minimum price" />
                                                <input type="number" id="price-max-input" class="price-max-input" data-price-max-input placeholder="$ Max" min="0" value="[[CUSTOM_MAX]]" aria-label="Maximum price" />
                                            </div>
                                        </div>
                                        <button type="button" class="price-apply-btn" id="price-apply-btn" data-price-apply-btn ${DL_FILTER_APPLY}>Apply</button>
                                        <div id="price-range-error" class="price-range-error hidden" data-price-range-error role="alert" aria-live="polite"></div>
                                    </li>
                                </ul>
                            </fieldset>
                        </li>`,
  };

  class SearchanizeProducts extends HTMLElement {
    settings = {
      cachedData: {},
      startIndex: 0,
      currentPage: 0,
      isLoading: false,
      isLoadMore: false,
      isPriceFilter: false,
      activePriceRange: null,
      customMinPrice: '',
      customMaxPrice: '',
      renderOfferTemplate: false,
      infiniteScrollObserver: null,
      // Brand collections use click-based pagination (button) instead of infinite scroll observer.
      loadMoreClickInitialized: false,
      loadMoreTotalItems: 0,
      loadMoreItemsPerPage: 0,
      loadMoreHasMore: false,
      isMobile: window.innerWidth <= 768,
      similarProductTotalItems: 0,
      similarProductStartIndex: 0,
      similarProductCurrentPage: 0,
      similarProductItemsPerPage: 15,
      activeElementId: null,
    };

    constructor() {
      super();

      this.productHandle = '';
      this.isShowingSimilarProducts = false;

      this.pageType = this.getAttribute('data-page-type');
      this.isSpecialCollection = this.getAttribute('data-is-special-collection') == 'true';
      this.isMiniPerfume = false;

      this.isBrandCollection = this.getAttribute('data-is-brand-collection') === 'true';
      this.isMacOS = /Mac/.test(navigator.userAgentData?.platform || navigator.platform || '');

      if (this.pageType === 'search') {
        this.collectionHandle = '';
      } else {
        this.collectionHandle = this.extractHandle(
          this.getAttribute('data-handle') || '',
          'collection'
        );
        if (!this.collectionHandle) return;

         // Detect mini-perfume from the collection handle — most reliable source
        this.isMiniPerfume =
          this.collectionHandle.includes('mini-perfume') ||
          this.getAttribute('data-is-mini-perfume') === 'true';

        if (this.isSpecialCollection || this.isMiniPerfume) {
          this.settings.renderOfferTemplate = true;
        }
      }

      this.buildSelectors();
      this.fetchProducts(true);
    }

    buildSelectors() {
      this.selectors = {};
      this.selectors.html = document.querySelector('html');
      this.selectors.body = document.querySelector('body');
      this.selectors.overlay = document.querySelector('.wrapper-overlay');

      this.selectors.srStatus = this.querySelector('#sr-status');
      this.selectors.mainContainer = this.querySelector('[data-main-container]');
      this.selectors.sidebarContainer = this.querySelector('[data-sidebar-container]');

      if (this.settings.isMobile || this.isBrandCollection) {
        this.selectors.filterContainer = this.querySelector(
          '[data-mobile-filter] [data-filter-container]'
        );
      } else {
        this.selectors.filterContainer = this.querySelector(
          '[data-desktop-filter] [data-filter-container]'
        );
      }
      this.selectors.productsContainer = this.querySelector('[data-products-container]');

      this.selectors.mobFilterOpen = this.querySelector('[data-mob-filter-open]');
      this.selectors.mobFilterClose = this.querySelectorAll('[data-mob-filter-close]');

      this.selectors.sortByDiv = this.querySelector('[data-sortby]');
      this.selectors.sortByBtn = this.querySelector('[data-sortby] [data-sortby-btn]');
      this.selectors.sortByList = this.querySelector('[data-sortby] [data-sortby-list]');

      this.selectors.showDiv = this.querySelector('[data-limited-view]');
      this.selectors.showBtn = this.querySelector('[data-limited-view] [data-showProduct-btn]');
      this.selectors.showList = this.querySelector('[data-limited-view] [data-showProduct-list]');

      this.selectors.loadMoreBtn = this.querySelector('[data-loadmore-btn]');
      this.selectors.productCounts = this.querySelectorAll('[data-result-count]');
      this.selectors.productsBannerBottom = this.querySelector('[data-banner-bottom]');

      this.selectors.clearAllBtns = this.querySelectorAll('[data-filter-clear-all]');
      this.selectors.viewAllBtnMob = this.querySelector('[data-mob-filter-close].apply-mob-filter');
      this.selectors.clearAllBtnMob = this.querySelector(
        '[data-filter-clear-all].clear-mob-filter'
      );
      this.selectors.clearAllBtnDesk = this.querySelector(
        '[data-filter-clear-all].clear-desk-filter'
      );

      this.collectionDefaultEnable = this.getAttribute('data-collection-defult-enable');
      this.collectionDefaultSorting = this.getAttribute('data-collection-defult-sorting');

      if (this.selectors.sortByBtn) {
        this.selectors.sortByBtn.removeAttribute('aria-labelledby');
        this.selectors.sortByBtn.removeAttribute('aria-label');
      }

      if (this.selectors.filterContainer) {
        this.selectors.filterContainer.addEventListener('input', (evt) => {
          const target = evt.target;
          if (target.classList.contains('brand-search-input')) {
            const query = target.value.toLowerCase().trim();
            this.settings.brandSearchQuery = target.value;
            const clearBtn = target.closest('.filter_search')?.querySelector('.brand-search-clear');
            if (clearBtn) {
              clearBtn.classList.toggle('hidden', !target.value);
            }
            const ul = target.closest('.widget')?.querySelector('.list-tags');
            if (ul) {
              ul.scrollTop = 0;
              let noResults = ul.querySelector('.no-brand-results');
              if (!noResults) {
                noResults = document.createElement('li');
                noResults.className = 'no-brand-results hidden';
                noResults.textContent = 'No brands found';
                ul.appendChild(noResults);
              }
              const listItems = Array.from(ul.querySelectorAll('li:not(.no-brand-results)'));
              let hasMatches = false;
              listItems.forEach((li) => {
                const txt = li.querySelector('label')?.textContent.toLowerCase() || '';
                const idx = query ? (txt.indexOf(query) === -1 ? 9999 : txt.indexOf(query)) : 0;
                if (idx < 9999) {
                  li.classList.remove('hidden');
                  li.style.display = '';
                  hasMatches = true;
                } else {
                  li.classList.add('hidden');
                }
                li.setAttribute('data-idx', idx);
              });
              noResults.classList.toggle('hidden', hasMatches);
              listItems.sort((a, b) => (Number(a.getAttribute('data-idx')) - Number(b.getAttribute('data-idx'))) || a.querySelector('label')?.textContent.localeCompare(b.querySelector('label')?.textContent))
                       .forEach((li) => ul.appendChild(li));
              ul.appendChild(noResults);
            }
          }
        });

        this.selectors.filterContainer.addEventListener('keydown', (evt) => {
          if (evt.target.classList.contains('brand-search-input') && evt.key === 'Enter') {
            evt.preventDefault();
          }
        });

        this.selectors.filterContainer.addEventListener('click', (evt) => {
          if (evt.target.classList.contains('brand-search-clear')) {
            const input = evt.target.closest('.filter_search')?.querySelector('.brand-search-input');
            if (input) {
              input.value = '';
              input.dispatchEvent(new Event('input', { bubbles: true }));
              input.focus();
            }
          }
        });
      }
    }
    buildAPIURL(initialRender) {
      let baseurl = `https://www.searchanise.com/getresults?api_key=2K7F7z9Y9V&items=true&facets=true&facetsShowUnavailableOptions=false&output=jsonp`;

      const selectedFilterValues = Array.from(
        this.selectors.filterContainer.querySelectorAll('[data-attr-key]')
      )
        .map((filterItem) => {
          let values = '';
          const attrKey = filterItem.dataset.attrKey;
          const selectedInputs = Array.from(
            filterItem.querySelectorAll(
              '[data-filter-option-container] input[type="checkbox"]:checked'
            )
          );

          if (attrKey == 'price' && this.settings.isPriceFilter && this.settings.activePriceRange) {
            if (this.settings.activePriceRange === 'custom') {
              const minVal = this.settings.customMinPrice || filterItem.querySelector('[data-price-min-input]')?.value || 0;
              const maxVal = this.settings.customMaxPrice || filterItem.querySelector('[data-price-max-input]')?.value || 10000;
              values = `${minVal},${maxVal}`;
            } else {
              values = this.settings.activePriceRange;
            }
            selectedInputs.length = 1;
          } else {
            values = selectedInputs
              .map((input) => encodeURIComponent(input.value.trim()))
              .join('|');
          }

          return selectedInputs.length === 0 ? '' : `restrictBy[${attrKey}]=${values}`;
        })
        .filter((value) => value);

      const selectedShowValue =
        this.selectors.showList.querySelector('[aria-selected="true"]').dataset.value || '12';

      if (selectedFilterValues.length) baseurl += `&${selectedFilterValues.join('&')}`;

      baseurl = this.collectionSorting(initialRender, baseurl);

      baseurl += `&startIndex=${this.settings.startIndex}&maxResults=${selectedShowValue}`;

      const url_obj = new URL(window.location.href);
      const searchQuery = url_obj.searchParams.get('q') || '';
      if (searchQuery && this.pageType === 'search') {
        baseurl += `&q=${encodeURIComponent(searchQuery)}`;
      }

      if (this.collectionHandle != '' && this.pageType === 'collection') {
        baseurl += `&categories=true&collection=${this.collectionHandle}`;
      }

      return baseurl;
    }

    collectionSorting(initialRender, baseurl) {
      let selectedSortByValue =
        this.selectors.sortByList.querySelector('[aria-selected="true"]').dataset.value ||
        'sales_amount&sortOrder=desc';

      if (initialRender) {
        if (this.collectionDefaultEnable == 'true' || this.collectionDefaultEnable == true) {
          if (this.collectionDefaultSorting.indexOf('price-descending') > -1) {
            selectedSortByValue = 'price&sortOrder=desc';
          } else if (this.collectionDefaultSorting.indexOf('price-ascending') > -1) {
            selectedSortByValue = 'price&sortOrder=asc';
          } else if (this.collectionDefaultSorting.indexOf('created-descending') > -1) {
            selectedSortByValue = 'created&sortOrder=desc';
          } else if (this.collectionDefaultSorting.indexOf('best-selling') > -1) {
            selectedSortByValue = 'sales_amount&sortOrder=desc';
          } else if (this.collectionDefaultSorting.indexOf('manual') > -1) {
            selectedSortByValue = 'sales_amount&sortOrder=desc';
          }
          baseurl += `&sortBy=${selectedSortByValue}`;
          const element = document.querySelector(
            '.filter-sortby .dropdown-menu li[data-value="' + selectedSortByValue + '"]'
          );
          if (element) {
            const labelText = document.querySelector(
              '.filter-sortby .optionsContainer .label-text'
            );
            if (labelText) {
              labelText.textContent = element.textContent;
            }
            const btn = document.querySelector('.filter-sortby button[data-sortby-btn]');
            if (btn) {
              btn.removeAttribute('aria-label');
            }

            // Set selected state for the target element
            element.setAttribute('aria-selected', 'true');
            element.classList.add('active');

            // Remove selected state from other elements
            const allElements = document.querySelectorAll('.filter-sortby .dropdown-menu li');
            allElements.forEach((el) => {
              if (el.getAttribute('data-value') !== selectedSortByValue) {
                el.setAttribute('aria-selected', 'false');
                el.classList.remove('active');
              }
            });
          }
        } else {
          baseurl += `&sortBy=${selectedSortByValue}`;
        }
      } else {
        baseurl += `&sortBy=${selectedSortByValue}`;
      }
      return baseurl;
    }

    async fetchProducts(initialRender, suppressSRStatus = false) {
      if (this.brandFilterTimeout) {
        clearTimeout(this.brandFilterTimeout);
        this.brandFilterTimeout = null;
      }
      try {
        _theme.toggleLoading(true);

        // Handle similar search load more
        if (this.isShowingSimilarProducts && !initialRender) {
          return await this.loadMoreSimilarProducts();
        }

        const apiUrl = this.buildAPIURL(initialRender);
        if (!apiUrl) {
          throw new Error('Invalid API URL');
        }

        if (this.settings.infiniteScrollObserver) {
          this.settings.infiniteScrollObserver.unobserve(this.selectors.loadMoreBtn);
        }

        let result = null;
        this.settings.isLoading = true;
        this.updateSRStatus(suppressSRStatus);

        if (this.settings.cachedData[apiUrl]) {
          result = this.settings.cachedData[apiUrl];
        } else {
          const resp = await fetch(apiUrl);
          if (!resp.ok) {
            throw new Error(`Error: ${resp}`);
          }

          result = await resp.json();
          if (!result) {
            throw new Error('Invalid Response');
          }

          this.settings.cachedData[apiUrl] = result;
        }

        if (this.isMiniPerfume && result && result.items) {
          if (!this.allSeenProducts || initialRender || !this.settings.isLoadMore) {
            this.allSeenProducts = result.items;
          } else {
            result.items.forEach((item) => {
              if (!this.allSeenProducts.some((p) => p.product_id === item.product_id)) {
                this.allSeenProducts.push(item);
              }
            });
          }
        }


        const hasActiveFilters =
          this.settings.isPriceFilter ||
          !!this.selectors.filterContainer?.querySelector('input:checked');

        if (result.totalItems === 0) {
          if (this.pageType === 'search' && !hasActiveFilters) {
            // Try to get similar products using similar search
            this.trySimilarProducts();
          } else {
            if (this.pageType !== 'search') {
              this.selectors.mainContainer
                ?.querySelector('[data-toolbar-container]')
                ?.classList.add('hidden');
            }
            const noProductsMsg = `Sorry, no products found ${hasActiveFilters ? 'matching your filters' : ''}`;
            this.selectors.productsContainer.innerHTML =
              `<p class="col-12 text-center">${noProductsMsg}</p>`;
            this.noProductsMessage = noProductsMsg;
            this.selectors.productCounts?.forEach((countElem) => {
              countElem.textContent = '0 Products';
            });
            if (result.facets && result.facets.length) {
              this.renderFilters(result);
            }
          }
          this.settings.isLoading = false;
        } else {
          this.noProductsMessage = null;
          this.renderProducts(result);
          this.renderFilters(result);
          if (initialRender) {
            this.initInitialEvents();
          }
          this.initInfiniteScrollLoadMore(result);
          this.settings.isLoadMore = false;
          this.settings.isLoading = false;
          _theme.Wishlist.init();
        }

        if (this.settings.activeElementId) {
          const elemToFocus = document.getElementById(this.settings.activeElementId);
          if (elemToFocus) {
            elemToFocus.focus({ preventScroll: true });
          }
          this.settings.activeElementId = null;
        }

        setTimeout(() => {
          this.updateSRStatus(suppressSRStatus);
          _theme.toggleLoading(false);
        }, 500);
      } catch (error) {
        console.error('Error:', error);
        _theme.toggleLoading(false);
      }
    }

    sortProductsByAvailability(result) {
      if (!result.items) return;

      if (!this.isMiniPerfume) { 
        return result;
      }
      const selectedSortByValue = this.selectors.sortByList?.querySelector('[aria-selected="true"]')?.dataset?.value || '';
        const getMiniVariantPrice = (product) => {
          const v = product.shopify_variants?.find((v) => {
            const sizeRaw = (v.options?.Size || v.title || '').trim();
            const match = sizeRaw.match(/^(\d+(?:\.\d+)?)\s*oz/i);
            return match && parseFloat(match[1]) === 1.0;
          });
          return v && v.price ? parseFloat(v.price) : 0;
        };

        result.items.sort((a, b) => {
          const aAvailable = a.shopify_variants?.some((v) => {
            const sizeRaw = (v.options?.Size || v.title || '').trim();
            const match = sizeRaw.match(/^(\d+(?:\.\d+)?)\s*oz/i);
            return match && parseFloat(match[1]) === 1.0 && v.available !== '0';
          }) ? 1 : 0;

          const bAvailable = b.shopify_variants?.some((v) => {
            const sizeRaw = (v.options?.Size || v.title || '').trim();
            const match = sizeRaw.match(/^(\d+(?:\.\d+)?)\s*oz/i);
            return match && parseFloat(match[1]) === 1.0 && v.available !== '0';
          }) ? 1 : 0;

          if (aAvailable !== bAvailable) {
            return bAvailable - aAvailable;
          }

          if (selectedSortByValue === 'price&sortOrder=asc') {
            return getMiniVariantPrice(a) - getMiniVariantPrice(b);
          } else if (selectedSortByValue === 'price&sortOrder=desc') {
            return getMiniVariantPrice(b) - getMiniVariantPrice(a);
          } else if (selectedSortByValue === 'title&sortOrder=asc') {
            return (a.title || '').localeCompare(b.title || '');
          } else if (selectedSortByValue === 'title&sortOrder=desc') {
            return (b.title || '').localeCompare(a.title || '');
          }
          return 0;
        });
         return result;
    }

    renderProducts(result) {
      if (!result || result.totalItems === 0) return;

      try {
        const sortVal = this.selectors.sortByList?.querySelector('[aria-selected="true"][data-value]')?.getAttribute('data-value') || '';
        
        const getMinPrice = (item) => {
            if (!item.shopify_variants || !Array.isArray(item.shopify_variants) || item.shopify_variants.length === 0) return 0;
            const prices = item.shopify_variants.map(v => Number(v.price)).filter(p => !isNaN(p));
            return prices.length > 0 ? Math.min(...prices) : 0;
        };

        if (sortVal === 'price&sortOrder=asc') {
            result.items.sort((a, b) => getMinPrice(a) - getMinPrice(b));
        } else if (sortVal === 'price&sortOrder=desc') {
            result.items.sort((a, b) => getMinPrice(b) - getMinPrice(a));
        }
      } catch (error) {
          console.warn('Silent fallback: Error during client-side sorting', error);
      }

      let mainHtml = '';
      let renderedCount = 0;
      const totalItemsCount = result.totalItems;
      const renderItems = this.isMiniPerfume && this.settings.isLoadMore ? this.allSeenProducts : result.items;
      const sortedResult = this.sortProductsByAvailability({items:renderItems});
      const itemsToRender = sortedResult?.items || renderItems || [];
      itemsToRender.forEach((product, index) => {
        // Filter: For offer collections, only show products with offer variants in stock
        if (this.settings.renderOfferTemplate && !this.isMiniPerfume) {
          // Check if product has offer metafield (applicable_offer)
          const productOffer = product.metafield_b9ba57cd478d42c60429674e481c50c1;
          if (productOffer) {
            // Check if any variant has is_offer_applicable = true AND is in stock
            const hasOfferVariantInStock = product.shopify_variants?.some(
              (variant) =>
                variant.search_variant_metafields_data
                  ?.variant_metafield_25c7b979d6abf42fb11a9be16739134f === 'true' &&
                variant.available !== '0'
            );

            // Skip this product if no offer variant is in stock
            if (!hasOfferVariantInStock) {
              return;
            }
          }
        }

        // Filter: For mini-perfume, only show products that have a 1.0 oz variant
        if (this.isMiniPerfume) {
          const has1oz = product.shopify_variants?.some((v) => {
            const sizeRaw = (v.options?.Size || v.title || '').trim();
            const match = sizeRaw.match(/^(\d+(?:\.\d+)?)\s*oz/i);
            return match && parseFloat(match[1]) === 1.0;
          });
          if (!has1oz) return;
        }

        renderedCount++;

        this.productHandle = this.extractHandle(product.link, 'product') || '';

        const variant = this.getFirstAvailableVariant(product);
        const productImages = this.buildProductImage(product, variant);
        const vid = variant ? variant.variant_id : product.shopify_variants?.[0]?.variant_id || '';

        let product_html = _theme.product_html.productCardTemplate;

        // Map values to placeholders
        product_html = _theme.Helpers.updateHtml(product_html, '[[Variant_Id]]', vid);
        product_html = _theme.Helpers.updateHtml(
          product_html,
          '[[Product_Id]]',
          product.product_id
        );
        product_html = _theme.Helpers.updateHtml(
          product_html,
          '[[Product_Handle]]',
          this.productHandle
        );
        product_html = _theme.Helpers.updateHtml(product_html, '[[Product_URL]]', product.link);
        product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Title]]', product.title);
        product_html = _theme.Helpers.updateHtml(
          product_html,
          '[[Product_Vendor]]',
          product.vendor || ''
        );

        // Complex components
        product_html = _theme.Helpers.updateHtml(
          product_html,
          '[[Product_Badges]]',
          this.buildProductBadge(product)
        );
        product_html = _theme.Helpers.updateHtml(
          product_html,
          '[[Product_Image]]',
          productImages.image_1
        );
        product_html = _theme.Helpers.updateHtml(
          product_html,
          '[[Product_Type]]',
          this.buildProductType(product)
        );
        product_html = _theme.Helpers.updateHtml(
          product_html,
          '[[Product_Reviews]]',
          this.buildProductReviewSummary(product)
        );
        product_html = _theme.Helpers.updateHtml(
          product_html,
          '[[Product_Price]]',
          this.buildProductPrice(product)
        );
        product_html = _theme.Helpers.updateHtml(
          product_html,
          '[[Product_Actions]]',
          this.buildProductActionButton(product)
        );
        product_html = _theme.Helpers.updateHtml(
          product_html,
          '[[Product_Notify_CTA]]',
          this.buildProductNotifyMeButton(product)
        );
        product_html = _theme.Helpers.updateHtml(
          product_html,
          '[[Product_Card_Class]]',
          this.updateGridClass(product)
        );
        product_html = _theme.Helpers.updateHtml(
          product_html,
          '[[Product_JSON]]',
          this.buildProductJSON(product)
        );

        mainHtml += product_html;

        const promo_index = this.isBrandCollection ? 8 : 6;
        if (index == promo_index && this.selectors.productsBannerBottom) {
          mainHtml += this.selectors.productsBannerBottom.innerHTML;
        }
      });

      if (this.settings.isLoadMore) {
         if (this.isMiniPerfume) {
          this.selectors.productsContainer.innerHTML = mainHtml;
         }else{
        this.selectors.productsContainer.insertAdjacentHTML('beforeend', mainHtml);
         }
      } else {
        this.selectors.productsContainer.innerHTML = mainHtml;
      }

      // UI state updates
      if (this.pageType === 'search') {
        this.classList.remove('hidden');
        const searchContainer = this.closest('[data-search-container]');
        if (searchContainer) {
          searchContainer.querySelector('[data-search-breadcrumbs]')?.classList.remove('hidden');
          searchContainer.querySelector('[data-no-search-breadcrumbs]')?.classList.add('hidden');
          searchContainer.querySelector('[data-search-result-main]')?.classList.add('hidden');
        }
      } else {
        this.selectors.mainContainer
          ?.querySelector('[data-toolbar-container]')
          ?.classList.remove('hidden');
      }

      const displayCount = (typeof totalItemsCount !== 'undefined' && totalItemsCount !== null && !this.isMiniPerfume) ? totalItemsCount : renderedCount;
      this.selectors.productCounts.forEach((countElem) => {
        countElem.textContent = `${displayCount} ${displayCount === 1 ? 'Product' : 'Products'}`;
      });

      if (this.selectors.viewAllBtnMob) {
        const mobTotal = typeof totalItemsCount !== 'undefined' && totalItemsCount !== null ? totalItemsCount : renderedCount;
        this.selectors.viewAllBtnMob.innerHTML = `View (${mobTotal})`;
        this.selectors.viewAllBtnMob.setAttribute(
          'aria-label',
          `View all ${mobTotal} products`
        );
      }
      this.updateSRStatus();
    }
    renderFilters(result) {
      if (!result || result.totalItems === 0) return;

      const facetContainsBrandTag = (facet) => {
        if (!facet || !Array.isArray(facet.buckets)) return false;

        if (typeof facet.title === 'string' && (facet.title.trim() === 'Brand' || facet.title.trim() === 'Vendor' || facet.title.trim().toLowerCase() === 'brand' || facet.title.trim().toLowerCase() === 'vendor')) return true;
        if (typeof facet.default_title === 'string' && (facet.default_title.trim() === 'Brand' || facet.default_title.trim() === 'Vendor' || facet.default_title.trim().toLowerCase() === 'brand' || facet.default_title.trim().toLowerCase() === 'vendor')) {
          return true;
        }
        if (typeof facet.attribute === 'string' && (facet.attribute.trim() === 'vendor' || facet.attribute.trim() === 'brand')) return true;

        return facet.buckets.some(
          (bucket) => typeof bucket?.value === 'string' && /^brand[_-]/i.test(bucket.value)
        );
      };

      const previouslyOpenKeys = new Set(
        Array.from(
          this.selectors.filterContainer.querySelectorAll('.widget.open-accordion[data-attr-key]')
        ).map((el) => el.dataset.attrKey)
      );

      let mainHtml = '';
      let price_to = 0;
      let price_from = 0;
      let price_to_left = 0;
      let price_from_left = 0;
      let filter_Selected = false;

      result.facets.forEach((facet, facetIndex) => {
        // if (this.isBrandCollection && facet.attribute === 'vendor') return;
        const isBrandTagInFilter = facetContainsBrandTag(facet);
        if (this.isBrandCollection && (facet.attribute === 'vendor' || isBrandTagInFilter)) return;
        // Checkbox-like toggle condition for removing the size filter option for miniperfume collection
        const removeSizeFilterForMiniPerfume = true;
        if (
          removeSizeFilterForMiniPerfume &&
          this.isMiniPerfume &&
          (facet.attribute === 'size' || facet.title.toLowerCase() === 'size')
        )
          return;

        let filterOptionMainHtml = '';
        const item_title = facet.title.trim().toLowerCase();
        let filterItemHtml = templates.filterItem;
        filterItemHtml = _theme.Helpers.updateHtml(filterItemHtml, '[[FILTER_TITLE]]', facet.title);
        filterItemHtml = _theme.Helpers.updateHtml(
          filterItemHtml,
          '[[FILTER_ATTR_KEY]]',
          facet.attribute
        );

        let filter_selected_count = 0;
        let filter_open_accordion = previouslyOpenKeys.has(facet.attribute);
        const seenBrands = new Set();
        if (isBrandTagInFilter && this.settings.brandSearchQuery && facet.buckets) {
          const query = this.settings.brandSearchQuery.toLowerCase().trim();
          const getIdx = (val) => {
            const i = val.toLowerCase().indexOf(query);
            return i === -1 ? 9999 : i;
          };
          facet.buckets.sort((a, b) => {
            const valA = (typeof a.value === 'string' ? a.value : '').replace(/^brand[_-]/i, '');
            const valB = (typeof b.value === 'string' ? b.value : '').replace(/^brand[_-]/i, '');
            return (getIdx(valA) - getIdx(valB)) || valA.localeCompare(valB);
          });
        }
        facet.buckets.forEach((option, optionIndex) => {
          if (this.isMiniPerfume) {
            const cleanOptVal = (option.value || '').trim().toLowerCase();
            if (cleanOptVal === 'eminence' || cleanOptVal === 'beauty') {
              return;
            }
          }

          const displayCount = option.count;


          if (item_title == 'price') {
            if (optionIndex === 0) {
              price_from = Number(option.from);
              price_to = Number(option.to);
              price_from_left = Number(option.left);
              price_to_left = Number(option.right);

              let priceOptionHtml = templates.filterPriceOption;
              let dynamicRadiosHtml = '';

              const activeRange = this.settings.activePriceRange;

              if (this.settings.isPriceFilter && activeRange) {
                filter_Selected = true;
                filter_selected_count = 1;
                filter_open_accordion = true;
              }

              if (facet.buckets && facet.buckets.length > 1) {
                facet.buckets.forEach((bucket) => {
                  const bFrom = Number(bucket.from || 0);
                  const bTo = Number(bucket.to || 100000);
                  const rangeValue = `${bFrom},${bTo}`;
                  const radioId = `price-range-${bFrom}-${bTo}`;
                  const isChecked = activeRange === rangeValue ? 'checked="checked"' : '';

                  let labelText = '';
                  if (bFrom === 0) {
                    labelText = `Under ${Shopify.formatMoney(bTo * 100, window.money_format)}`;
                  } else if (bTo >= 100000) {
                    labelText = `${Shopify.formatMoney(bFrom * 100, window.money_format)} and above`;
                  } else {
                    labelText = `${Shopify.formatMoney(bFrom * 100, window.money_format)} to ${Shopify.formatMoney(bTo * 100, window.money_format)}`;
                  }

                  if (bucket.count !== undefined) {
                    labelText += ` (${bucket.count})`;
                  }

                  dynamicRadiosHtml += `
                    <li class="price-range-item">
                        <input type="radio" id="${radioId}" name="price_range" value="${rangeValue}" aria-label="${labelText}" ${isChecked} ${DL_FILTER_SELECT} />
                        <label for="${radioId}" aria-hidden="true" ${DL_FILTER_SELECT}>${labelText}</label>
                    </li>`;
                });
              } else {
                const customRangesAttr = this.getAttribute('data-price-ranges');
                const defaultRanges = customRangesAttr ? customRangesAttr.split('\n').map(line => {
                  const parts = line.trim().split(':');
                  return parts.length === 2 ? { value: parts[0].trim(), label: parts[1].trim() } : null;
                }).filter(Boolean) : [];

                defaultRanges.forEach(range => {
                  const radioId = `price-range-${range.value.replace(',', '-')}`;
                  const isChecked = (activeRange === range.value || (range.value === '100,100000' && activeRange === '100,10000')) ? 'checked="checked"' : '';
                  dynamicRadiosHtml += `
                    <li class="price-range-item" role="presentation">
                        <input type="radio" id="${radioId}" name="price_range" value="${range.value}" data-price-range="${range.value}" aria-label="${range.label}" ${isChecked} ${DL_FILTER_SELECT} />
                        <label for="${radioId}" aria-hidden="true" ${DL_FILTER_SELECT}>${range.label}</label>
                    </li>`;
                });
              }

              const isCustom = activeRange === 'custom' ? 'checked="checked"' : '';
              const customMin = this.settings.customMinPrice || '';
              const customMax = this.settings.customMaxPrice || '';

              priceOptionHtml = _theme.Helpers.updateHtml(priceOptionHtml, '[[DYNAMIC_PRICE_RADIOS]]', dynamicRadiosHtml);
              priceOptionHtml = _theme.Helpers.updateHtml(priceOptionHtml, '[[CHECKED_CUSTOM]]', isCustom);
              priceOptionHtml = _theme.Helpers.updateHtml(priceOptionHtml, '[[CUSTOM_MIN]]', customMin);
              priceOptionHtml = _theme.Helpers.updateHtml(priceOptionHtml, '[[CUSTOM_MAX]]', customMax);

              filterOptionMainHtml += priceOptionHtml;
            }
          } else {
            let optionHtml = templates.filterOption;
            const optionValue = typeof option.value === 'string' ? option.value : '';

            let displayValue = optionValue;
            if (isBrandTagInFilter) {
              displayValue = displayValue.replace(/^brand[_-]/i, '');
              const brandKey = displayValue.toLowerCase().trim();
              if (seenBrands.has(brandKey)) return;
              seenBrands.add(brandKey);
            }

            const optionLabel = displayValue + ' (' + displayCount + ')';
            optionHtml = _theme.Helpers.updateHtml(
              optionHtml,
              '[[FILTER_OPTION_ID]]',
              _theme.Helpers.handleize(`${facet.title}-${displayValue}-${optionIndex}`)
            );
            optionHtml = _theme.Helpers.updateHtml(
              optionHtml,
              '[[FILTER_OPTION_VALUE]]',
              optionValue
            );
            optionHtml = _theme.Helpers.updateHtml(
              optionHtml,
              '[[FILTER_OPTION_TITLE]]',
              optionLabel
            );
            optionHtml = _theme.Helpers.updateHtml(
              optionHtml,
              '[[FILTER_OPTION_ARIA_LABEL]]',
              this.isMacOS ? `aria-label="${optionLabel}"` : ''
            );
            optionHtml = _theme.Helpers.updateHtml(
              optionHtml,
              '[[FILTER_OPTION_LABEL_ATTRS]]',
              this.isMacOS ? 'aria-hidden="true"' : ''
            );
            optionHtml = _theme.Helpers.updateHtml(
              optionHtml,
              '[[FILTER_OPTION_SELECTED]]',
              option.selected === 'true' ? 'checked' : ''
            );

            let displayStyle = '';
            if (isBrandTagInFilter && this.settings.brandSearchQuery) {
              const query = this.settings.brandSearchQuery.toLowerCase().trim();
              if (!displayValue.toLowerCase().includes(query)) {
                displayStyle = 'style="display: none;"';
              }
            }
            optionHtml = _theme.Helpers.updateHtml(
              optionHtml,
              '[[FILTER_OPTION_STYLE]]',
              displayStyle
            );
            filterOptionMainHtml += optionHtml;
          }
          if (item_title !== 'price' && option.selected === 'true') {
            filter_Selected = true;
            filter_selected_count += 1;
            filter_open_accordion = true;
          }
          if (facetIndex === 0 && !this.settings.isMobile) {
            filter_open_accordion = true;
          }
        });

        if (isBrandTagInFilter) {
          const hasMatches = facet.buckets && facet.buckets.some((option) => {
            const displayValue = (typeof option.value === 'string' ? option.value : '').replace(/^brand[_-]/i, '');
            return !this.settings.brandSearchQuery || displayValue.toLowerCase().includes(this.settings.brandSearchQuery.toLowerCase().trim());
          });
          filterOptionMainHtml += `<li class="no-brand-results${hasMatches ? ' hidden' : ''}">No brands found</li>`;
        }

        filterItemHtml = _theme.Helpers.updateHtml(
          filterItemHtml,
          '[[FILTER_OPTIONS]]',
          filterOptionMainHtml
        );
        filterItemHtml = _theme.Helpers.updateHtml(
          filterItemHtml,
          '[[FILTER_SELECTED_COUNT]]',
          filter_selected_count > 0 ? `(${filter_selected_count})` : ''
        );
        filterItemHtml = _theme.Helpers.updateHtml(
          filterItemHtml,
          '[[FILTER_ACCORDION_CLASS]]',
          filter_open_accordion ? 'open-accordion' : ''
        );
        filterItemHtml = _theme.Helpers.updateHtml(
          filterItemHtml,
          '[[FILTER_ACCORDION_ATTR]]',
          filter_open_accordion ? 'aria-expanded="true"' : 'aria-expanded="false"'
        );
        filterItemHtml = _theme.Helpers.updateHtml(
          filterItemHtml,
          '[[FILTER_ACCORDION_STYLE]]',
          filter_open_accordion ? 'style="display:block"' : 'style="display:none"'
        );

        if (isBrandTagInFilter && facet.buckets && facet.buckets.length > 1) {
          const storedQuery = this.settings.brandSearchQuery || '';
          const searchBoxHtml = `<div class="filter_search">
            <input
              type="text"
              aria-label="Search by brand"
              placeholder="Search by brand"
              class="outline-inset brand-search-input"
              value="${storedQuery.replace(/"/g, '&quot;')}"
            />
            <button type="button" class="brand-search-clear${storedQuery ? '' : ' hidden'}" aria-label="Clear search" ${DL_FILTER_SELECT}>&times;</button>
          </div>`;
          filterItemHtml = _theme.Helpers.updateHtml(
            filterItemHtml,
            '[[FILTER_SEARCH_BOX]]',
            searchBoxHtml
          );
        } else {
          filterItemHtml = _theme.Helpers.updateHtml(
            filterItemHtml,
            '[[FILTER_SEARCH_BOX]]',
            ''
          );
        }
        mainHtml += filterItemHtml;
      });

      this.selectors.filterContainer.innerHTML = mainHtml;

      this.selectors.viewAllBtnMob.classList.toggle('disabled', !filter_Selected);
      this.selectors.clearAllBtnMob.classList.toggle('disabled', !filter_Selected);
      this.selectors.viewAllBtnMob.toggleAttribute('disabled', !filter_Selected);
      this.selectors.clearAllBtnMob.toggleAttribute('disabled', !filter_Selected);

      this.selectors.clearAllBtnDesk.style.display = filter_Selected ? 'block' : 'none';

      this.selectors.overlay.addEventListener('click', this.closeMobSidebarFilter.bind(this));
      this.selectors.mobFilterOpen.addEventListener('click', this.openMobSidebarFilter.bind(this));
      this.selectors.mobFilterClose.forEach((btn) => {
        btn.addEventListener('click', () => {
          const shouldAnnounceResults = btn.classList.contains('apply-mob-filter');
          this.closeMobSidebarFilter({ announceResults: shouldAnnounceResults });
        });
      });

      const filterContainerBtns = this.selectors.filterContainer.querySelectorAll('.sidebar-title');
      filterContainerBtns.forEach((btn) => {
        const toggleAccordion = (evt) => {
          const parent = btn.closest('.widget');
          const title = parent.querySelector('.sidebar-title');
          const content = parent.querySelector('.widget-content');
          parent.classList.toggle('open-accordion');

          const isOpen = content.style.display === 'block';
          content.style.display = isOpen ? 'none' : 'block';
          title.setAttribute('aria-expanded', !isOpen);
        };

        btn.addEventListener('click', toggleAccordion);
        btn.addEventListener('keydown', (evt) => {
          if (evt.key === 'Enter' || evt.key === ' ') {
            evt.preventDefault();
            toggleAccordion(evt);
          }
        });
      });

      const filterInputs = this.selectors.filterContainer.querySelectorAll(
        '[data-filter-option-container] input[type="checkbox"]'
      );
      filterInputs.forEach((input) => {
        input.addEventListener('change', (evt) => {
          this.settings.activeElementId = evt.target.id;
          this.settings.isPriceFilter = false;
          this.resetFilters();

          const parentWidget = input.closest('[data-title]');
          const isBrandFilter = parentWidget && (
            parentWidget.getAttribute('data-title') === 'Brand' ||
            parentWidget.getAttribute('data-attr-key') === 'vendor' ||
            evt.target.id.startsWith('brand-') ||
            evt.target.id.startsWith('vendor-')
          );

          if (isBrandFilter) {
            _theme.toggleLoading(true);
            if (this.brandFilterTimeout) {
              clearTimeout(this.brandFilterTimeout);
            }
            this.brandFilterTimeout = setTimeout(() => {
              this.fetchProducts(false, true);
            }, 500);
          } else {
            if (this.brandFilterTimeout) {
              clearTimeout(this.brandFilterTimeout);
            }
            this.fetchProducts(false, true);
          }
        });

        input.addEventListener('keydown', (evt) => {
          if (evt.key === 'Enter') {
            evt.preventDefault();
            input.checked = !input.checked;
            input.dispatchEvent(new Event('change'));
          }
        });
      });

      {
        const priceRadios = this.selectors.filterContainer.querySelectorAll('input[name="price_range"]');
        priceRadios.forEach(radio => {
          radio.addEventListener('click', (evt) => {
            const errorElem = this.selectors.filterContainer.querySelector('[data-price-range-error]');
            if (errorElem) {
              errorElem.textContent = '';
              errorElem.classList.add('hidden');
            }

            if (this.settings.activePriceRange === radio.value && this.settings.isPriceFilter) {
              evt.preventDefault();
              radio.checked = false;
              this.settings.isPriceFilter = false;
              this.settings.activePriceRange = null;
              this.settings.customMinPrice = '';
              this.settings.customMaxPrice = '';
              const minInput = this.selectors.filterContainer.querySelector('[data-price-min-input]');
              const maxInput = this.selectors.filterContainer.querySelector('[data-price-max-input]');
              if (minInput) {
                minInput.value = '';
                minInput.removeAttribute('aria-invalid');
              }
              if (maxInput) {
                maxInput.value = '';
                maxInput.removeAttribute('aria-invalid');
              }
              this.resetFilters();
              this.fetchProducts(false, true);
              return;
            }

            this.filterModalTriggerKey = 'price';
            if (evt.currentTarget instanceof HTMLInputElement && evt.currentTarget.id) {
              this.settings.activeElementId = evt.currentTarget.id;
            }
            this.settings.activePriceRange = radio.value;
            if (radio.value !== 'custom') {
              this.settings.isPriceFilter = true;
              this.resetFilters();
              this.fetchProducts(false, true);
            }
          });
        });

        const minInput = this.selectors.filterContainer.querySelector('[data-price-min-input]');
        const maxInput = this.selectors.filterContainer.querySelector('[data-price-max-input]');
        const customRadio = this.selectors.filterContainer.querySelector('[data-price-range-custom]');

        if (minInput) {
          minInput.addEventListener('input', () => {
            this.settings.customMinPrice = minInput.value;
            if (!minInput.value && !maxInput?.value) {
              if (customRadio) customRadio.checked = false;
              this.settings.activePriceRange = null;
              this.settings.isPriceFilter = false;
            } else {
              if (customRadio) customRadio.checked = true;
              this.settings.activePriceRange = 'custom';
            }
            minInput.removeAttribute('aria-invalid');
            const errorElem = this.selectors.filterContainer.querySelector('[data-price-range-error]');
            if (errorElem) {
              errorElem.textContent = '';
              errorElem.classList.add('hidden');
            }
          });
        }
        if (maxInput) {
          maxInput.addEventListener('input', () => {
            this.settings.customMaxPrice = maxInput.value;
            if (!maxInput.value && !minInput?.value) {
              if (customRadio) customRadio.checked = false;
              this.settings.activePriceRange = null;
              this.settings.isPriceFilter = false;
            } else {
              if (customRadio) customRadio.checked = true;
              this.settings.activePriceRange = 'custom';
            }
            maxInput.removeAttribute('aria-invalid');
            const errorElem = this.selectors.filterContainer.querySelector('[data-price-range-error]');
            if (errorElem) {
              errorElem.textContent = '';
              errorElem.classList.add('hidden');
            }
          });
        }

        const handleApplyCustomPrice = () => {
          const errorElem = this.selectors.filterContainer.querySelector('[data-price-range-error]');
          if (!this.validateCustomPriceRange(minInput, maxInput, errorElem)) {
            return;
          }
          this.filterModalTriggerKey = 'price';
          if (customRadio) customRadio.checked = true;
          this.settings.activePriceRange = 'custom';
          this.settings.customMinPrice = minInput?.value || '';
          this.settings.customMaxPrice = maxInput?.value || '';
          this.settings.isPriceFilter = true;
          this.resetFilters();
          this.fetchProducts(false);
        };

        const applyBtn = this.selectors.filterContainer.querySelector('[data-price-apply-btn]');
        if (applyBtn) {
          applyBtn.addEventListener('click', handleApplyCustomPrice);
        }

        [minInput, maxInput].forEach(input => {
          if (input) {
            input.addEventListener('keydown', (evt) => {
              if (evt.key === 'Enter') {
                evt.preventDefault();
                handleApplyCustomPrice();
              }
            });
          }
        });
      }
    }

    validateCustomPriceRange(minInput, maxInput, errorElem) {
      minInput = minInput || this.querySelector('[data-price-min-input]');
      maxInput = maxInput || this.querySelector('[data-price-max-input]');
      errorElem = errorElem || this.querySelector('[data-price-range-error]');

      if (errorElem) {
        errorElem.textContent = '';
        errorElem.classList.add('hidden');
      }
      if (minInput) minInput.removeAttribute('aria-invalid');
      if (maxInput) maxInput.removeAttribute('aria-invalid');

      const parseValStr = (input) => {
        if (!input || !input.value) return '';
        return input.value.trim().replace(/[^0-9.-]/g, '');
      };

      const minValStr = parseValStr(minInput);
      const maxValStr = parseValStr(maxInput);

      if (!minValStr && !maxValStr) {
        if (errorElem) {
          errorElem.textContent = 'Please enter a minimum or maximum price.';
          errorElem.classList.remove('hidden');
        }
        return false;
      }

      const minVal = minValStr !== '' ? Number(minValStr) : null;
      const maxVal = maxValStr !== '' ? Number(maxValStr) : null;

      if (minVal !== null && (isNaN(minVal) || minVal < 0)) {
        if (minInput) minInput.setAttribute('aria-invalid', 'true');
        if (errorElem) {
          errorElem.textContent = 'Minimum price must be a valid number 0 or greater.';
          errorElem.classList.remove('hidden');
        }
        return false;
      }

      if (maxVal !== null && (isNaN(maxVal) || maxVal <= 0)) {
        if (maxInput) maxInput.setAttribute('aria-invalid', 'true');
        if (minVal === 0 && minInput) minInput.setAttribute('aria-invalid', 'true');
        if (errorElem) {
          errorElem.textContent = 'Maximum price must be greater than 0.';
          errorElem.classList.remove('hidden');
        }
        return false;
      }

      if (minVal !== null && maxVal !== null && minVal > maxVal) {
        if (minInput) minInput.setAttribute('aria-invalid', 'true');
        if (maxInput) maxInput.setAttribute('aria-invalid', 'true');
        if (errorElem) {
          errorElem.textContent = 'Minimum price cannot be greater than maximum price.';
          errorElem.classList.remove('hidden');
        }
        return false;
      }

      return true;
    }
    resetFilters() {
      this.settings.startIndex = 0;
      this.settings.currentPage = 0;
      this.settings.isLoadMore = false;
    }

    // Helper method for similar search API calls
    async fetchSimilarProducts(startIndex, maxResults) {
      const similarApiUrl =
        'https://searchserverapi.com/getwidgets?api_key=2K7F7z9Y9V&output=jsonp&items=true&maxResults=1000&suggestions=true&suggestionsMaxResults=5&pages=true&pagesMaxResults=10&categories=true&categoryStartIndex=0&categoriesMaxResults=5';

      const url_obj = new URL(window.location.href);
      const searchQuery = url_obj.searchParams.get('q') || '';

      const response = await fetch(
        `${similarApiUrl}&q=${encodeURIComponent(searchQuery)}&startIndex=${startIndex}&maxResults=${maxResults}`
      );
      if (!response.ok) {
        throw new Error('Similar search failed');
      }

      return await response.json();
    }
    async trySimilarProducts() {
      try {
        const similarResult = await this.fetchSimilarProducts(
          this.settings.similarProductStartIndex,
          this.settings.similarProductItemsPerPage
        );

        if (similarResult.totalItems > 0) {
          this.classList.add('search-similar-products');
          this.showSimilarProducts(similarResult);
        } else {
          this.showNoSimilarProducts();
        }
      } catch (error) {
        this.showNoSimilarProducts();
      }
    }
    showSimilarProducts(result) {
      this.isShowingSimilarProducts = true;

      // Store the total count for pagination
      this.settings.similarProductTotalItems = result.totalItems;
      this.settings.similarProductCurrentPage = 0;
      this.settings.similarProductStartIndex = 0;

      // Reset loading flag for similar search
      this.settings.isLoading = false;

      // Render the products using existing method
      this.renderProducts(result);

      // Initialize infinite scroll for similar search
      this.initInfiniteScrollLoadMore(result);

      // Initialize Wishlist
      _theme.Wishlist.init();
    }
    showNoSimilarProducts() {
      this.classList.add('hidden');
      this.closest('[data-search-container]')
        .querySelector('[data-search-breadcrumbs]')
        .classList.add('hidden');
      this.closest('[data-search-container]')
        .querySelector('[data-search-result-main]')
        .classList.remove('hidden');
      this.closest('[data-search-container]')
        .querySelector('[data-no-search-breadcrumbs]')
        .classList.remove('hidden');
    }
    async loadMoreSimilarProducts() {
      try {
        const similarResult = await this.fetchSimilarProducts(
          this.settings.similarProductStartIndex,
          this.settings.similarProductItemsPerPage
        );

        if (similarResult.totalItems > 0) {
          this.renderProducts(similarResult);
          // Reinitialize infinite scroll for next batch
          this.initInfiniteScrollLoadMore(similarResult);
        }

        this.settings.isLoading = false;
        _theme.toggleLoading(false);
      } catch (error) {
        console.error('Error loading more similar search results:', error);
        this.settings.isLoading = false;
        _theme.toggleLoading(false);
      }
    }

    initInitialEvents() {
      if (this.selectors.sortByBtn) {
        const parent = this.selectors.sortByBtn.closest('.filter-sortby');
        this.selectors.sortByBtn.addEventListener('focus', () => {
          if (parent) parent.classList.add('focused');
          this.selectors.sortByBtn.classList.add('focused');
        });
        this.selectors.sortByBtn.addEventListener('blur', () => {
          if (parent) parent.classList.remove('focused');
          this.selectors.sortByBtn.classList.remove('focused');
        });
      }

      // Show product
      const showItems = Array.from(this.selectors.showList.querySelectorAll('li'));
      showItems.forEach((showItem) => {
        showItem.addEventListener('keydown', (evt) => {
          if (evt.key === 'Enter') {
            evt.preventDefault();
            evt.stopPropagation();
            evt.stopImmediatePropagation();
            showItem.click();
          }
          if (evt.key === 'Tab') {
            this.closeShowMenu();
          }
        });

        showItem.addEventListener('click', (evt) => {
          showItems
            .filter((item) => item !== showItem)
            .forEach((item) => {
              item.setAttribute('aria-selected', false);
              item.classList.remove('active');
            });

          const showLabel = showItem.dataset.text;
          this.selectors.showBtn.querySelector('strong.label-text').textContent = showLabel;

          showItem.setAttribute('aria-selected', true);
          showItem.classList.add('active');

          this.closeShowMenu();
          this.resetFilters();
          this.fetchProducts(false);
        });
      });

      this.selectors.showBtn.addEventListener('click', (evt) => {
        const isOpen = JSON.parse(this.selectors.showBtn.getAttribute('aria-expanded'));
        if (isOpen) {
          this.closeShowMenu(evt.target);
        } else {
          this.openShowMenu(evt.target);
        }
      });
      this.selectors.showDiv.addEventListener('keyup', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();

        let selectedElem = this.selectors.showList.querySelector('li[aria-selected="true"]');
        if (!selectedElem) selectedElem = this.selectors.showList.querySelector('li');

        const target = evt.target;
        const nextElem = selectedElem.nextElementSibling;
        const prevElem = selectedElem.previousElementSibling;

        if (evt.key === 'Escape') {
          this.closeShowMenu();
          this.selectors.showBtn.focus();
        }

        if (evt.key === 'ArrowUp' && prevElem) {
          evt.preventDefault();
          selectedElem.setAttribute('aria-selected', false);
          prevElem.setAttribute('aria-selected', true);
          prevElem.focus();
        }

        if (evt.key === 'ArrowDown' && nextElem) {
          evt.preventDefault();
          selectedElem.setAttribute('aria-selected', false);
          nextElem.setAttribute('aria-selected', true);
          nextElem.focus();
        }

        if (evt.key === 'Tab' && !this.selectors.showDiv.contains(target)) {
          this.closeShowMenu();
        }
      });

      // Sort by
      const sortByItems = Array.from(this.selectors.sortByList.querySelectorAll('li')).filter(
        (li) => {
          if (!li.dataset.text || li.dataset.text.trim() === '') {
            li.style.display = 'none';
            return false;
          }
          return true;
        }
      );
      sortByItems.forEach((sortItem) => {
        sortItem.addEventListener('keydown', (evt) => {
          if (evt.key === 'Enter' || evt.key === ' ') {
            evt.preventDefault();
            evt.stopPropagation();
            evt.stopImmediatePropagation();
            sortItem.click();
          }
          if (evt.key === 'Tab') {
            this.closeSortByMenu();
          }
        });

        sortItem.addEventListener('click', (evt) => {
          sortByItems
            .filter((item) => item !== sortItem)
            .forEach((item) => {
              item.setAttribute('aria-selected', false);
              item.classList.remove('active');
            });

          const sortLabel = sortItem.dataset.text;
          this.selectors.sortByBtn.querySelector('strong.label-text').textContent = sortLabel;
          this.selectors.sortByBtn.removeAttribute('aria-label');

          sortItem.setAttribute('aria-selected', true);
          sortItem.classList.add('active');

          this.closeSortByMenu();
          this.selectors.sortByBtn.focus();
          this.resetFilters();
          this.isSortFilterApplied = true;

          // Only fetch products if not showing similar products
          if (!this.isShowingSimilarProducts) {
            this.fetchProducts(false);
          }
        });
      });

      const toggleSortByMenu = (evt) => {
        if (evt.type === 'keydown' && evt.key !== ' ' && evt.key !== 'Enter') return;
        evt.preventDefault();
        evt.stopPropagation();

        const isOpen = this.selectors.sortByBtn.getAttribute('aria-expanded') === 'true';
        isOpen ? this.closeSortByMenu() : this.openSortByMenu();
      };

      this.selectors.sortByBtn.addEventListener('click', toggleSortByMenu);
      this.selectors.sortByBtn.addEventListener('keydown', toggleSortByMenu);

      this.selectors.sortByDiv.addEventListener('keyup', (evt) => {
        const listItems = Array.from(this.selectors.sortByList.querySelectorAll('li')).filter(
          (li) => li.style.display !== 'none'
        );
        const focusedElem =
          this.selectors.sortByList.contains(document.activeElement) &&
          document.activeElement.tagName === 'LI'
            ? document.activeElement
            : this.selectors.sortByList.querySelector('li[aria-selected="true"]') ||
              this.selectors.sortByList.querySelector('li');

        const focusedIndex = listItems.indexOf(focusedElem);
        const nextElem = listItems[focusedIndex + 1] || null;
        const prevElem = listItems[focusedIndex - 1] || null;
        const target = evt.target;

        if (evt.key === 'Escape') {
          evt.preventDefault();
          evt.stopPropagation();
          this.closeSortByMenu();
          this.selectors.sortByBtn.focus();
        }

        if (evt.key === 'Tab' && !this.selectors.sortByDiv.contains(target)) {
          this.closeSortByMenu();
        }

        if (evt.key === 'ArrowDown' && nextElem) {
          evt.preventDefault();
          evt.stopPropagation();
          nextElem.focus();
        }

        if (evt.key === 'ArrowUp' && prevElem) {
          evt.preventDefault();
          evt.stopPropagation();
          prevElem.focus();
        }
      });

      // Clear All
      this.selectors.clearAllBtns.forEach((btn) => {
        btn.addEventListener('click', (evt) => {
          const filterInputs = this.selectors.filterContainer.querySelectorAll(
            '[data-filter-option-container] input[type="checkbox"]'
          );
          filterInputs.forEach((input) => {
            input.checked = false;
          });

          this.settings.isPriceFilter = false;
          this.settings.activePriceRange = null;
          this.settings.customMinPrice = '';
          this.settings.customMaxPrice = '';
          const priceRadios = this.selectors.filterContainer?.querySelectorAll('input[name="price_range"]');
          if (priceRadios) priceRadios.forEach(r => r.checked = false);
          const priceMinInput = this.selectors.filterContainer?.querySelector('[data-price-min-input]');
          const priceMaxInput = this.selectors.filterContainer?.querySelector('[data-price-max-input]');
          const priceErrorElem = this.selectors.filterContainer?.querySelector('[data-price-range-error]');
          if (priceMinInput) {
            priceMinInput.value = '';
            priceMinInput.removeAttribute('aria-invalid');
          }
          if (priceMaxInput) {
            priceMaxInput.value = '';
            priceMaxInput.removeAttribute('aria-invalid');
          }
          if (priceErrorElem) {
            priceErrorElem.textContent = '';
            priceErrorElem.classList.add('hidden');
          }
          this.resetFilters();
          this.settings.brandSearchQuery = '';
          this.fetchProducts(false, true);
          this.closeMobSidebarFilter();
          setTimeout(() => {
            document.querySelector('#sr-status').textContent = 'All filters cleared';
          }, 1000);
        });
      });

      document.body.addEventListener('click', (evt) => {
        const target = evt.target;

        const sortBy = this.selectors.sortByDiv;
        if (sortBy && target !== sortBy && !sortBy.contains(target)) {
          this.closeSortByMenu();
        }

        const show = this.querySelector('[data-limited-view]');
        if (show && target !== show && !show.contains(target)) {
          this.closeShowMenu();
        }
      });
    }
    initInfiniteScrollLoadMore(result) {
      if (!this.selectors || !this.selectors.loadMoreBtn) return;

      const loadMoreBtn = this.selectors.loadMoreBtn;
      const loadMoreWrapper = loadMoreBtn.closest('.loadmore-btn-wrapper');

      const setBrandLoadMoreUI = (hasMore) => {
        // Default CSS keeps it invisible (opacity: 0). For brand pages we want it visible as a real button.
        if (loadMoreWrapper) {
          loadMoreWrapper.style.opacity = hasMore ? '1' : '0';
          loadMoreWrapper.style.pointerEvents = hasMore ? 'auto' : 'none';
        }
        loadMoreBtn.disabled = !hasMore;
        loadMoreBtn.setAttribute('aria-hidden', String(!hasMore));
        loadMoreBtn.tabIndex = hasMore ? 0 : -1;
      };

      let totalItems;
      let itemsPerPage;
      let total_page;
      let hasMore = false;

      if (this.isShowingSimilarProducts) {
        totalItems = this.settings.similarProductTotalItems || result.totalItems;
        itemsPerPage = this.settings.similarProductItemsPerPage;
        total_page = Math.ceil(totalItems / itemsPerPage);

        this.settings.similarProductStartIndex = result.startIndex || 0;
        if (this.settings.similarProductCurrentPage < total_page && totalItems > itemsPerPage) {
          const totalLoadedProducts = this.settings.similarProductStartIndex + itemsPerPage;
          hasMore = totalLoadedProducts < totalItems;
        }

        this.settings.loadMoreTotalItems = totalItems;
        this.settings.loadMoreItemsPerPage = itemsPerPage;
      } else {
        // Regular pagination
        totalItems = result.totalItems;
        itemsPerPage = result.itemsPerPage;
        total_page = Math.ceil(totalItems / itemsPerPage);

        this.settings.startIndex = result.startIndex;
        if (this.settings.currentPage < total_page && totalItems > itemsPerPage) {
          const totalLoadedProducts = this.settings.startIndex + itemsPerPage;
          hasMore = totalLoadedProducts < totalItems;
        }

        this.settings.loadMoreTotalItems = totalItems;
        this.settings.loadMoreItemsPerPage = itemsPerPage;
      }

      this.settings.loadMoreHasMore = hasMore;

      if (this.isBrandCollection) {
        setBrandLoadMoreUI(hasMore);

        // Ensure infinite scroll observer is disabled on brand pages.
        if (this.settings.infiniteScrollObserver) {
          this.settings.infiniteScrollObserver.disconnect();
          this.settings.infiniteScrollObserver = null;
        }

        if (!this.settings.loadMoreClickInitialized) {
          this.settings.loadMoreClickInitialized = true;

          loadMoreBtn.addEventListener('click', (evt) => {
            evt.preventDefault();

            if (this.settings.isLoading) return;
            if (!this.settings.loadMoreHasMore) return;
            if (loadMoreBtn.disabled) return;

            this.settings.isLoadMore = true;

            if (this.isShowingSimilarProducts) {
              this.settings.similarProductCurrentPage++;
              this.settings.similarProductStartIndex =
                this.settings.similarProductCurrentPage * this.settings.similarProductItemsPerPage;
            } else {
              this.settings.currentPage++;
              this.settings.startIndex =
                this.settings.currentPage * this.settings.loadMoreItemsPerPage;
            }

            // Prevent multiple clicks while loading; we will re-enable UI after next render.
            setBrandLoadMoreUI(false);
            this.fetchProducts(false);
          });
        }

        return;
      }

      // Regular collections: keep infinite scroll observer.
      if (!hasMore) return;

      const viewportBtm = (window.innerHeight * 40) / 100 + 'px';
      const config = {
        root: null,
        rootMargin: `0px 0px ${viewportBtm} 0px`,
        threshold: 0.05,
      };

      this.settings.infiniteScrollObserver = new IntersectionObserver((entries, observer) => {
        if (this.settings.isLoading) return;

        if (entries[0].isIntersecting) {
          this.settings.isLoadMore = true;

          if (this.isShowingSimilarProducts) {
            // Similar search pagination
            this.settings.similarProductCurrentPage++;
            this.settings.similarProductStartIndex =
              this.settings.similarProductCurrentPage * this.settings.similarProductItemsPerPage;
          } else {
            // Regular pagination
            this.settings.currentPage++;
            this.settings.startIndex = this.settings.currentPage * result.itemsPerPage;
          }

          observer.unobserve(this.selectors.loadMoreBtn);
          this.fetchProducts(false);
        }
      }, config);

      this.settings.infiniteScrollObserver.observe(this.selectors.loadMoreBtn);
    }

    // Build Methods
    buildProductBadge(product) {
      if (!product) return '';

      const timerSettings = window.countdownTimerSettings || {};
      const expressSettings = _theme.settings?.express_shipping || {};

      const isFlashExtensionActive = !!timerSettings.flashSaleExtensionActive;
      const isFlashTimerActive = this.isTimerActive(timerSettings);
      const isExpressEnabled = expressSettings.enabled === 'Enable';
      const expressThreshold = Number(expressSettings.quantity_threshold || 2);
      const deliveryDays = expressSettings.delivery_days || '2';
      const productOffer = product.metafield_b9ba57cd478d42c60429674e481c50c1 || '';

      const variant = this.getFirstAvailableVariant(product);
      const vid = variant ? variant.variant_id : product.shopify_variants?.[0]?.variant_id || '';

      // Reconstruct product JSON for component
      const productJson = {
        id: product.product_id,
        tags: (typeof product.tags === 'string'
          ? product.tags.split('[:ATTR:]')
          : product.tags || []
        ).map((t) => t.trim().toLowerCase()),
        variants:
          product.shopify_variants?.map((v) => ({
            id: v.variant_id,
            price: Number(v.price) * 100,
            compare_at_price: Number(v.list_price) * 100,
            available: v.available !== '0',
            title: v.title,
          })) || [],
      };

      // Reconstruct variant meta JSON for component
      const variantMetaJson =
        product.shopify_variants?.map((v) => ({
          id: v.variant_id,
          enable_flash_sale:
            v.search_variant_metafields_data?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca,
          allow_express_shipping:
            v.search_variant_metafields_data?.variant_metafield_070071a13a8ea5aafeb0b99afa0c101f,
          brightperl_variant_inventory:
            v.search_variant_metafields_data?.variant_metafield_69f1d8722b9c470908fa53fe850945fb,
          is_offer_applicable:
            v.search_variant_metafields_data?.variant_metafield_25c7b979d6abf42fb11a9be16739134f,
        })) || [];

      const badgeMode = this.settings.renderOfferTemplate ? 'variant-level' : 'product-level';

      return `
        <product-badges-component
          data-product-id="${product.product_id}"
          data-selected-variant-id="${vid}"
          data-is-offer-collection="${this.settings.renderOfferTemplate}"
          data-badge-mode="${badgeMode}"
          data-max-badges="2"
          data-flash-sale-extension="${isFlashExtensionActive}"
          data-flash-sale-timer="${isFlashTimerActive}"
          data-express-shipping-enabled="${isExpressEnabled}"
          data-express-shipping-threshold="${expressThreshold}"
          data-delivery-days="${deliveryDays}"
          data-product-offer="${_theme.Helpers.escapeHtml(productOffer)}"
        >
          <script type="application/json" data-product-badges-json>
            ${JSON.stringify(productJson)}
          </script>
          <script type="application/json" data-product-badges-variant-meta-json>
            ${JSON.stringify(variantMetaJson)}
          </script>

          <div class="product-card__badge_root" data-product-badges-root></div>
        </product-badges-component>
      `;
    }
    buildProductImage(product, variant = null) {
      const primaryImage =
        variant?.image_link ||
        product.image_link ||
        'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';

      let secondaryImage = '';
      if (Array.isArray(product.shopify_images) && product.shopify_images.length > 1) {
        secondaryImage =
          product.shopify_images.find((image) => image && image !== primaryImage) || '';
      } else if (typeof product.shopify_images === 'string') {
        const imageList = product.shopify_images
          .replace(/\[|\]/g, '')
          .split(/,|\[:IMG:\]|\|/g)
          .map((item) => item.trim())
          .filter(Boolean);
        secondaryImage = imageList.find((image) => image && image !== primaryImage) || '';
      }

      if (
        !secondaryImage &&
        product.secondary_image_link &&
        product.secondary_image_link !== primaryImage
      ) {
        secondaryImage = product.secondary_image_link;
      }

      const image_1 = `
        <div class="product-card__image-stack${secondaryImage ? ' product-card__image-stack--has-secondary' : ''}">
          <img src="${primaryImage}" alt="${_theme.Helpers.escapeHtml(product.title)}" class="product-card__img product-card__image-primary" loading="lazy" width="300" height="300">
          ${secondaryImage ? `<img src="${secondaryImage}" alt="" class="product-card__img product-card__image-secondary" loading="lazy" width="300" height="300" aria-hidden="true">` : ''}
        </div>
      `;

      return { image_1 };
    }
    buildProductType(product) {
      const productType =
        product.metafield_9e14d49086f4ac1134f463aa2738d80e || product.product_type || '';
      if (!productType) return '';

      return productType;
    }
    buildProductReviewSummary(product) {
      const metadata = product['metafield_68be2c8c872cca8e6b86ad08cbae727c'] || '';
      if (!metadata) return '';

      return `<div class="trustpilot-review-summary-wrapper">
                <trustpilot-review-summary
                  data-show-popup="false"
                  data-show-total="true"
                  data-show-average="true"
                  data-review-summary-metadata="${metadata.replace(/"/g, '&quot;')}"
                  data-product-url="${product.link}"
                  data-product-id="${product.product_id}"
                ></trustpilot-review-summary>
              </div>`;
    }
    buildProductPrice(product) {
      const isOfferCollection = this.settings.renderOfferTemplate;
      const productOffer = product.metafield_b9ba57cd478d42c60429674e481c50c1;
      const isBundleOffer = isOfferCollection && productOffer && productOffer.includes(' For $');

      if (isBundleOffer) {
        const variant = this.getFirstAvailableVariant(product);
        if (!variant) return '';

        const price = Shopify.formatMoney(variant.price * 100, window.money_format).replace(
          '.00',
          ''
        );
        const hasCompare = Number(variant.list_price) > Number(variant.price);
        const compareAt = hasCompare
          ? Shopify.formatMoney(variant.list_price * 100, window.money_format).replace('.00', '')
          : '';

        return `<div class="price-left">
                  ${
                    hasCompare
                      ? `
                    <span class="visually-hidden">Original price</span>
                    <span class="product-card__price-original-offer">${compareAt}</span>
                  `
                      : ''
                  }
                  <span class="visually-hidden">Sale price</span>
                  <span class="product-card__price-sale-offer">${price}</span>
                </div>
                <div class="variant-right">
                  <span>Size:</span> ${variant.options.Size || variant.title}
                </div>`;
      } else {
        const prices = product.shopify_variants?.map((variant) => Number(variant.price)) || [];
        if (prices.length === 0) return '';

        if (this.isMiniPerfume) {
          const minSizeVariant =
            product.shopify_variants?.find((v) => {
              const sizeRaw = (v.options?.Size || v.title || '').trim();
              const match = sizeRaw.match(/^(\d+(?:\.\d+)?)\s*oz/i);
              return match && parseFloat(match[1]) === 1.0;
            }) || null;

          if (minSizeVariant) {
            const price = Shopify.formatMoney(
              Number(minSizeVariant.price) * 100,
              window.money_format
            ).replace('.00', '');
            const compareAt =
              Number(minSizeVariant.list_price) > Number(minSizeVariant.price)
                ? Shopify.formatMoney(
                    Number(minSizeVariant.list_price) * 100,
                    window.money_format
                  ).replace('.00', '')
                : '';
            const sizeLabel = (minSizeVariant.options?.Size || minSizeVariant.title || '').trim();

            return `<div class="price-left">
                      ${
                        compareAt
                          ? `<span class="visually-hidden">Original price</span>
                             <span class="product-card__price-original-offer">${compareAt}</span>`
                          : ''
                      }
                      <span class="visually-hidden">Sale price</span>
                      <span class="product-card__price-sale-offer">${price}</span>
                    </div>
                    <div class="variant-right"><span>Size:</span> ${sizeLabel}</div>`;
          }
        }


        const minPrice = Math.min(...prices);
        const maxPrice = Math.max(...prices);

        if (minPrice !== maxPrice) {
          const minFormatted = Shopify.formatMoney(minPrice * 100, window.money_format).replace(
            '.00',
            ''
          );
          const maxFormatted = Shopify.formatMoney(maxPrice * 100, window.money_format).replace(
            '.00',
            ''
          );
          return `
                  <span class="visually-hidden">Price range</span>
                  <span class="product-card__price-sale">${minFormatted} - ${maxFormatted}</span>
                `;
        } else {
          const variant = product.shopify_variants[0];
          const price = Shopify.formatMoney(variant.price * 100, window.money_format).replace(
            '.00',
            ''
          );
          const compareAt = variant.list_price
            ? Shopify.formatMoney(variant.list_price * 100, window.money_format).replace('.00', '')
            : '';

          return `<div class="price-left">
                    <span class="visually-hidden">Sale price</span>
                    <span class="product-card__price-sale">${price}</span>
                    ${
                      Number(variant.list_price) > Number(variant.price)
                        ? `
                      <span class="visually-hidden">Original price</span>
                      <span class="product-card__price-original">${compareAt}</span>
                    `
                        : ''
                    }
                  </div>`;
        }
      }
    }
    buildProductActionButton(product) {
      if (this.settings.renderOfferTemplate) {
        const variant = this.getFirstAvailableVariant(product);
        if (!variant) return '';
        if (this.isMiniPerfume && variant.available === '0') {
          return '';
        }

        return `<product-form-component>
                  <div class="product-card__atc">
                    <span class='visually-hidden' id='product-card-atc-status-${product.product_id}' role='status' aria-live='polite' aria-atomic='true'></span>
                    <form method="post" action="/cart/add" id="product-card-form-${product.product_id}" class="product-card__form" novalidate="novalidate" data-type="add-to-cart-form">
                      <input type="hidden" name="form_type" value="product">
                      <input type="hidden" name="utf8" value="✓">
                      <input type="hidden" name="id" value="${variant.variant_id}" data-add-to-cart-var-id>
                      <add-to-cart-component>
                        <button type="button" class="button product-card__add-btn" data-add-to-cart-btn aria-controls="product-card-atc-status-${product.product_id}" aria-label="${variant.available ? 'Add to Cart' : 'Sold out'} ${_theme.Helpers.escapeHtml(product.title)}" ${DL_CTA}>
                          <span data-add-to-cart-text>Add to Cart</span>
                        </button>
                      </add-to-cart-component>
                      <input type="hidden" name="product-id" value="${product.product_id}">
                    </form>
                  </div>
                </product-form-component>`;
      }

      return '';
    }
    buildProductNotifyMeButton(product) {
      let html = '';
     const isAvailable = this.isMiniPerfume
        ? this.getFirstAvailableVariant(product)?.available !== '0'
        : this.isProductAvailable(product);

      if (!isAvailable) {
        let notifyHTML = _theme.product_html.notify_me;
        notifyHTML = _theme.Helpers.updateHtml(
          notifyHTML,
          '[[notify_me_product_id]]',
          product.product_id
        );
        html = notifyHTML;
      }

      return html;
    }
    buildProductJSON(product) {
      if (!product) return '';

      try {
        let html = '<script type="application/json" data-product-json>[[pjson]]</script>';
        let variantTitle = product.title;

        if (product.shopify_variants?.[0]?.options) {
          variantTitle = product.shopify_variants[0].options.Size || variantTitle;
        }

        const variantId = product.shopify_variants?.[0]?.variant_id || product.shopify_variants?.[0]?.id || product.variants?.[0]?.id || '';
        const pjson = {
          id: product.product_id,
          product_id: product.product_id,
          variant_id: variantId,
          title: product.title,
          product_title: product.title,
          vendor: product.vendor,
          type: product.product_type,
          product_type: product.product_type,
          discount: product.discount,
          collection_handle: this.collectionHandle || '',
          collection_title: this.collectionHandle
            ? this.collectionHandle.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())
            : '',
          collection_id: this.collectionHandle || '',
          item_list_id: this.collectionHandle || '',
          variant_title: variantTitle,
          price: Number(product.price),
          compareAtPrice: Number(product.list_price),
          compare_at_price: Number(product.list_price),
        };

        html = html.replace('[[pjson]]', JSON.stringify(pjson));
        return html;
      } catch (error) {
        return '';
      }
    }

    updateGridClass(product) {
      let html = '';
      const isAvailable = this.isProductAvailable(product);

      html = isAvailable ? 'available' : 'sold_out';
      return html;
    }
    updateSRStatus(suppress = false) {
      if (!this.selectors.srStatus || suppress) {
        if (this.selectors.srStatus) this.selectors.srStatus.textContent = '';
        return;
      }
      if (this.settings.isLoading) {
        this.selectors.srStatus.textContent = 'Content is loading';
      } else if (this.noProductsMessage) {
        this.selectors.srStatus.textContent = this.noProductsMessage;
        this.noProductsMessage = null;
      } else {
        const sortLabel = this.selectors.sortByBtn?.querySelector('strong.label-text')?.textContent || '';
        const countText = this.selectors.productCounts?.[0]?.textContent || '';
        let message = 'Content loaded successfully';
        if (this.isSortFilterApplied && sortLabel) {
          if (countText) {
            message = `Sorted by ${sortLabel}. ${countText} loaded successfully.`;
          } else {
            message = `Sorted by ${sortLabel}. Content loaded successfully.`;
          }
        }
        this.selectors.srStatus.textContent = message;
        this.isSortFilterApplied = false;
      }
      setTimeout(() => {
        if (this.selectors.srStatus) {
          this.selectors.srStatus.textContent = '';
        }
      }, 5000);
    }

    // Helper Methods
    isProductAvailable(product) {
      // Check if any variant is available (not "0")
      const isAvailable = product.shopify_variants.some(function (variant) {
        return variant.available !== '0'; // Return true if available
      });

      // Return true or false based on the availability
      return isAvailable ? true : false;
    }
    isTimerActive(timerSettings) {
      // Only consider timer active if enabled is true or 'True', everything else is false
      const enabled = timerSettings.enabled;
      if (enabled !== true && enabled !== 'True') {
        return false;
      }

      // Check if required date/time fields are present
      if (
        !timerSettings.startDate ||
        !timerSettings.startTime ||
        !timerSettings.endDate ||
        !timerSettings.endTime
      ) {
        return false;
      }

      const startDateTime = _theme.Helpers.parseESTDate(
        timerSettings.startDate,
        timerSettings.startTime
      ).getTime();
      const endDateTime = _theme.Helpers.parseESTDate(
        timerSettings.endDate,
        timerSettings.endTime
      ).getTime();
      const currentTime = _theme.Helpers.getCurrentESTTime();

      const isActive = currentTime >= startDateTime && currentTime <= endDateTime;

      return isActive;
    }
    getFirstAvailableVariant(product) {
           if (this.isMiniPerfume && product.shopify_variants) {
        const miniVariant = product.shopify_variants.find((v) => {
          const sizeRaw = (v.options?.Size || v.title || '').trim();
          const match = sizeRaw.match(/^(\d+(?:\.\d+)?)\s*oz/i);
          return match && parseFloat(match[1]) === 1.0 && v.available !== '0';
        });
        if (miniVariant) {
          return miniVariant;
        }
        const miniVariantAny = product.shopify_variants.find((v) => {
          const sizeRaw = (v.options?.Size || v.title || '').trim();
          const match = sizeRaw.match(/^(\d+(?:\.\d+)?)\s*oz/i);
          return match && parseFloat(match[1]) === 1.0;
        });
        if (miniVariantAny) {
          return miniVariantAny;
        }
      }
      if (!product.shopify_variants) return null;

      const timerSettings = window.countdownTimerSettings || {};
      const isFlashActive =
        this.isTimerActive(timerSettings) && timerSettings.flashSaleExtensionActive === true;

      const flashVariants = product.shopify_variants.filter(
        (variant) =>
          variant.search_variant_metafields_data
            ?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca === 'true' &&
          variant.available !== '0'
      );

      if (isFlashActive && flashVariants.length > 0) {
        return flashVariants[0];
      }

      const offerVariant = product.shopify_variants.find(
        (variant) =>
          variant.search_variant_metafields_data
            ?.variant_metafield_25c7b979d6abf42fb11a9be16739134f === 'true' &&
          variant.available !== '0'
      );

      if (offerVariant && this.settings.renderOfferTemplate) {
        return offerVariant;
      }

      return (
        product.shopify_variants.find((variant) => variant.available !== '0') ||
        product.shopify_variants[0]
      );
    }
    extractHandle(value, type) {
      if (!value) return '';

      const cleaned = value.split('?')[0].split('#')[0].replace(/\/$/, '');
      if (type === 'product') {
        const match = cleaned.match(/\/products\/([^\/]+)/);
        return match ? match[1] : '';
      }

      const match = cleaned.match(/\/collections\/([^\/]+)/);
      return match ? match[1] : cleaned;
    }

    openShowMenu() {
      this.selectors.showList.style.display = 'block';
      this.selectors.showBtn.setAttribute('aria-expanded', true);
    }
    closeShowMenu() {
      this.selectors.showList.style.display = 'none';
      this.selectors.showBtn.setAttribute('aria-expanded', false);
    }

    openSortByMenu() {
      this.selectors.sortByList.style.display = 'block';
      this.selectors.sortByBtn.setAttribute('aria-expanded', true);
    }
    closeSortByMenu() {
      this.selectors.sortByList.style.display = 'none';
      this.selectors.sortByBtn.setAttribute('aria-expanded', false);
    }

    openMobSidebarFilter(target) {
      this.selectors.overlay.classList.add('active');
      this.selectors.html.classList.add('sidebar-open');

      setTimeout(() => {
        const closeBtn = document.querySelector('.close-mob-trig-fil[data-mob-filter-close]');
        if (closeBtn) closeBtn.focus();

        const container = document.querySelector('[data-mobile-filter]');
        if (container) {
          const $container = $(container);
          _theme.focusTrap($container, () => this.closeMobSidebarFilter());

          this._mobFilterFocusinHandler = (e) => {
            if (container.contains(e.target)) return;
            _theme.focusFirstTabbable($container);
          };
          document.addEventListener('focusin', this._mobFilterFocusinHandler, true);
        }
        const c = document.querySelector('[data-mobile-filter]');
        c &&
          document
            .querySelectorAll('*')
            .forEach(
              (el) =>
                el !== c &&
                !c.contains(el) &&
                !el.contains(c) &&
                el.setAttribute('aria-hidden', 'true')
            );
      }, 500);
    }
    closeMobSidebarFilter({ announceResults = false } = {}) {
      this.selectors.overlay.classList.remove('active');
      this.selectors.html.classList.remove('sidebar-open');

      const container = document.querySelector('[data-mobile-filter]');
      if (container) {
        $(container).off('keydown');
      }
      if (this._mobFilterFocusinHandler) {
        document.removeEventListener('focusin', this._mobFilterFocusinHandler, true);
        this._mobFilterFocusinHandler = null;
      }
      setTimeout(() => {
        if (this.selectors.mobFilterOpen) this.selectors.mobFilterOpen.focus();
      }, 1000);
      if (announceResults) {
        setTimeout(() => {
          if (!this.selectors.srStatus || !this.selectors.productCounts.length) return;
          this.selectors.srStatus.textContent =
            'Showing ' + this.selectors.productCounts[0].textContent;
        }, 1000);
      }
      const c = document.querySelector('[data-mobile-filter]');
      c &&
        document
          .querySelectorAll('*')
          .forEach(
            (el) =>
              el !== c && !c.contains(el) && !el.contains(c) && el.removeAttribute('aria-hidden')
          );
    }
  }
  if (!customElements.get('searchanize-products')) {
    customElements.define('searchanize-products', SearchanizeProducts);
  }
})();
